export { default } from "./text";
export type { ITextProps } from "./text.types";
